module.exports = __webpack_public_path__ + "bd054752be3c638bc27a33c6d4a7dce9.svg";